'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Images = (_temp = _class = function (_SvgIcon) {
    _inherits(Images, _SvgIcon);

    function Images() {
        _classCallCheck(this, Images);

        return _possibleConstructorReturn(this, (Images.__proto__ || Object.getPrototypeOf(Images)).apply(this, arguments));
    }

    _createClass(Images, [{
        key: 'render',
        value: function () {
            function render() {
                return _react2['default'].createElement(
                    _SvgIcon3['default'],
                    this.props,
                    _react2['default'].createElement(
                        'g',
                        { fill: 'none', 'fill-rule': 'evenodd' },
                        _react2['default'].createElement('path', { d: 'M0 0h64v64H0z' }),
                        _react2['default'].createElement('path', { fill: '#00A5F7', d: 'M13.25 50.75h37.5v-37.5h-37.5z' }),
                        _react2['default'].createElement('path', { fill: '#55C7FF', d: 'M13.25 37.788L37.788 13.25H13.25z' }),
                        _react2['default'].createElement('path', { fill: '#417505', d: 'M13.25 50.75l9.375-15.625L32 50.75z' }),
                        _react2['default'].createElement('path', { fill: '#FFF', d: 'M22.625 42.156l2.11-3.515-2.11-3.516-2.11 3.516z' }),
                        _react2['default'].createElement('path', { fill: '#8FC056', d: 'M50.75 45.281l-9.375-16.406-12.5 21.875H50.75z' }),
                        _react2['default'].createElement('path', { fill: '#EBEBEB', d: 'M18.719 25.36a2.734 2.734 0 0 0 2.734 2.734h10.938a2.734 2.734 0 0 0 2.734-2.735 5.859 5.859 0 0 0-5.86-5.859 5.854 5.854 0 0 0-5.074 2.94 3.516 3.516 0 0 0-5.472 2.92' }),
                        _react2['default'].createElement('path', { fill: '#F0F1F1', d: 'M41.375 38.25l2.679-4.688-2.679-4.687-2.679 4.688z' }),
                        _react2['default'].createElement('path', { fill: '#545874', d: 'M16.375 7H7v9.375h2.344V9.344h7.031zM47.625 7H57v9.375h-2.344V9.344h-7.031zM57 47.625V57h-9.375v-2.344h7.031v-7.031zM7 47.625V57h9.375v-2.344H9.344v-7.031z' }),
                        _react2['default'].createElement('path', { fill: '#FFF', d: 'M29.266 19.5a5.854 5.854 0 0 0-5.075 2.94 3.516 3.516 0 0 0-5.472 2.92 2.734 2.734 0 0 0 2.734 2.734h1.492l8.258-8.259a5.832 5.832 0 0 0-1.937-.335' })
                    )
                );
            }

            return render;
        }()
    }]);

    return Images;
}(_SvgIcon3['default']), _class.defaultProps = {
    viewBox: '0 0 64 64'
}, _temp);
exports['default'] = Images;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Images.js
// module id = 1380
// module chunks = 32